<template>
  <div style="height: calc(100vh - 12vh); padding: 0 1vw">
    <div class="breadcrumb title-crumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>采购申请</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="container">
      <div class="header">
        <el-form :model="form">
          <el-row>
            <el-col :span="12">
              <el-form-item>
                <span class="label">订单名称：</span>
                <el-input v-model="form.orderName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
               <el-form-item>
                <span class="label">添加采购：</span>
                <el-button type="primary" @click="addFormVisible = true"
                  >从供应商库选择</el-button
                >
              </el-form-item>
            
            </el-col>
          </el-row>
          <el-row>
            <!-- <el-col :span="12">
              <el-form-item>
                <span class="label">采购单类型：</span>
                <el-input v-model="form.orderType"></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="12">
               <el-form-item>
                <span class="label">备注：</span>
                <el-input
                  type="textarea"
                  v-model="form.orderRemark"
                  style="width: 18vw"
                  :rows="2"
                  maxlength="50"
                  show-word-limit
                  placeholder="限50字以内"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <el-table :data="tableData" border height="60vh" style="width: 100%">
        <el-table-column
          prop="date"
          label="序号"
          width="80"
        >
        <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
        </template>
        
        </el-table-column>
        <el-table-column prop="date" label="采购名称">
          <template slot-scope="scope">
            <span>{{ scope.row.productName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="品牌">
          <template slot-scope="scope">
            <span>{{ scope.row.brand }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="供应商名称">
          <template slot-scope="scope">
            <span>{{ scope.row.manufacturer }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="date" label="规格">
          <template slot-scope="scope">
            <span>{{ scope.row.productSpecs }}</span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column prop="date" label="">
          <template slot-scope="scope">
            <span>{{ scope.row.productPrice }}</span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column prop="date" label="单位">
          <template slot-scope="scope">
            <span>{{ scope.row}}</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="date" label="数量">
          <template slot-scope="scope">
            <span>{{ scope.row.productCount }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="date" label="备注">
          <template slot-scope="scope">
            <span></span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" style="color: red">删除</el-button>
          </template>
        </el-table-column> -->
      </el-table>

      <div class="button">
        <el-button plain>取消</el-button>
        <el-button type="primary" @click="submit">提交</el-button>
      </div>
    </div>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="addFormVisible"
      center
      :append-to-body="true"
      :lock-scroll="false"
      class="add-form"
      width="99%"
    >
      <div class="tableAll">
        <!-- 产品列表 -->
        <div style="width: 45%">
          <h2
            style="
              background-image: linear-gradient(120deg,#a1c4fd 0%,#c2e9fb 100%);
              color: #fff;
              padding: 10px;
            "
          >
            产品列表
          </h2>
          <div
            class="dialogHead"
            style="display: flex; align-items: center; margin: 20px 0"
          >
            <span>产品名称:</span>
            <el-input
              placeholder="请输入产品名称"
              v-model="search.productName"
              clearable
            ></el-input>
            <span style="margin-left: 10px">供应商名称:</span>
            <el-input
              placeholder="请输入供应商名称"
              v-model="search.supplierName"
              clearable
            ></el-input>
            <el-button type="primary" style="margin-left: 1vw" @click="select"
              >查询</el-button
            >
          </div>
          <div class="dialogTable">
            <el-table
              stripe
              :data="productList"
              height="100%"
              style="width: 100%"
              :header-cell-style="{ background: '#F5F7F9', color: '#909399' }"
              ref="productList"
              border
            >
              <!-- <el-table-column type="selection" width="55">
            </el-table-column> -->
              <template slot="empty">
                <p>{{  }}</p>
              </template>
              <el-table-column label="序号" width="80">
                <template slot-scope="scope">
                  <a>{{ scope.$index + 1 }}</a>
                </template>
              </el-table-column>
              <el-table-column label="产品名称" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{ scope.row.productName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="品牌" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{ scope.row.brand }}</span>
                </template>
              </el-table-column>
              <el-table-column label="供应商名称">
                <template slot-scope="scope">
                  <span>{{ scope.row.manufacturer }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    type="primary"
                    style="margin-right: 1vw"
                    @click="handleAdd(scope.$index, scope.row)"
                  >
                    +
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <!-- 中间 -->
        <div style="width: 2%"></div>
        <!-- 购物车 -->
        <div style="width: 53%">
          <h2
            style="
              background-image: linear-gradient(-45deg,#ffc796 0%,#ff6b95 100%);
              color: #fff;
              padding: 10px;
            "
          >
            购物车列表
          </h2>
          <div
            class="dialogHead"
            style="
              display: flex;
              align-items: center;
              margin: 20px 0;
              height: 40px;
            "
          >
            <!-- 合计(元): <span style="color: #f00">{{ totalMoney }}</span> -->
          </div>
          <div class="dialogTable">
            <el-table
              stripe
              :data="carListNew"
              height="100%"
              style="width: 100%"
              :header-cell-style="{ background: '#F5F7F9', color: '#909399' }"
              ref="carListNew"
              border
            >
              <!-- <el-table-column type="selection" width="55">
            </el-table-column> -->
              <template slot="empty">
                <p>{{  }}</p>
              </template>
              <el-table-column label="序号" width="80">
                <template slot-scope="scope">
                  <a>{{ scope.$index + 1 }}</a>
                </template>
              </el-table-column>
              <el-table-column label="产品名称" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{ scope.row.productName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="品牌" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{ scope.row.brand }}</span>
                </template>
              </el-table-column>
              <el-table-column label="供应商名称" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{ scope.row.manufacturer }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="产品数量"
                show-overflow-tooltip
                width="220"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.productCount}}</span>
                  <!-- <el-input
                    v-model="scope.row.productCount"
                    @input="handleChange($event, scope.$index, scope.row)"
                  ></el-input> -->
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    type="danger"
                    icon="el-icon-delete"
                    style="margin-right: 1vw"
                    @click="handleDeleteItem(scope.$index, scope.row)"
                  ></el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="sumbitAddRow('addForm')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import base from '../../../untils/base'
import util from '../../../untils/util'
import myHttp from '../../../untils/port'
export default {
  data() {
    return {
      addFormVisible: false,
      tableData: [],
      productList: [],
      carListNew: [],
      dialogTitle: '',
      totalMoney: 0,
      search: {
        productName: '',
        supplierName: '',
      },
      form: {
        orderName: '',
        orderType: '',
        orderRemark: ''
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    select() {
      this.getData()
    },
    //获取产品列表数据
    getData() {
      myHttp
        .selectSupplierProductToBuy({
          porjectId: util.session.get('groupId'),
          productName: this.search.productName,
          supplierName: this.search.supplierName,
          orderRemark: ''
        })
        .then((resp) => {
          console.log(resp)
          this.productList = resp.data.data.list
        })
    },

    //添加采购单
    submit() {
      console.log(this.tableData);
      let detailList = []
      let obj = {
        productId: '',
        productCount: ''
      }
      // for(let i= 0;i<this.tableData.length;i++) {
      //   obj.productId = this.tableData[i].productId
      //   obj.productCount = this.tableData[i].productCount
      //   console.log(obj);
      //   detailList.push(JSON.parse(JSON.stringify(obj)))
      // }
      this.tableData.forEach(item => {
        obj.productId = item.productId
        obj.productCount = item.productCount
        detailList.push(JSON.parse(JSON.stringify(obj)))
        console.log(detailList);
      })
      console.log(detailList);
      detailList = JSON.stringify(detailList)
      myHttp.addPlannedPurchase({
        projectId: util.session.get('groupId'),
        orderName: this.form.orderName,
        orderType: 'cc_sp',
        orderRemark: this.form.orderRemark,
        detailList: detailList
      }).then(resp => {
        console.log(resp);
        if(resp.data.code == '200'){
           this.$message.success('添加成功')
           this.$router.push({
             path: '/buyCenter'
           })
        }else{
          this.$message.error(resp.data.msg)
        }
      })
    },
    handleAdd(index, row) {
      console.log(row)
      var arr = []
      var obj = {
        brand: row.brand,
        manufacturer: row.manufacturer,
        invoiceType: row.invoiceType,
        invoiceValue: row.invoiceValue,
        productCode: row.productCode,
        productId: row.productId,
        productName: row.productName,
        productPrice: row.productPrice,
        productSpecs: row.productSpecs,
        supplierId: row.supplierId,
        supplierName: row.supplierName,
        productRemark: row.productRemark,
        productCount: 1,
      }
      // this.carList.push(obj)

      // console.log( this.carList)
      this.carListNew = this.quchong(obj, this.carListNew)
      this.totalMoney = this.getMoney(this.carListNew)
      // console.log(this.carListNew)
    },
    quchong(obj, arr) {
      if (arr.length == 0) {
        arr.push(obj)
      } else {
        var isExit = false
        for (var i = 0; i < arr.length; i++) {
          if (obj.productId == arr[i].productId) {
            arr[i].productCount++
            isExit = true
          }
        }
        if (!isExit) {
          arr.push(obj)
        }
      }
      return arr
    },
    getMoney(list) {
      var total = 0
      list.forEach((item) => {
        total += parseFloat(item.productPrice) * parseFloat(item.productCount)
      })
      console.log(typeof total)
      return total.toFixed(2)
    },
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + 1 + index
    },
    handleChange(e, index, row) {
    console.log(e, row)
    this.$forceUpdate()
    // this.jugeNum(e)
    let regExp = /^[1-9]\d*$/
    if (!e) {
      // return
      e = 1
      this.$message.warning('该项为必填项')

      // 对第二个输入框进行正则校验
    } else if (regExp.test(e) === false) {
      e = 1
      this.$message.warning('只能输入大于等于1的正整数')
    } else {
      // return callback()
    }
    this.carListNew[index].productCount = e
    for (var i = 0; i < this.carList.length; i++) {
      if (row.productId == this.carListNew[i].productId) {
        this.carListNew[i].productCount = e
      }
    }
    this.totalMoney = this.getMoney(this.carListNew)
    // console.log( this.carListNew)
  },
  //提交
  sumbitAddRow(formName) {
    this.tableData = this.carListNew
    this.addFormVisible = false
    // console.log(this.listData )
  },
  //删除
  handleDeleteItem(index, row) {
    var that = this
    this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        that.carListNew.splice(index, 1)
        this.totalMoney = this.getMoney(this.carListNew)
      })
      .catch((err) => {})
  },
  
  },
}
</script>

<style scoped>
@import '../../../assets/css/common.css';
.container {
  height: 96%;
  background-color: #fff;
  padding: 1vh 1vw;
}
.header >>> .el-form-item__content {
  text-align: left;
}
.label {
  display: inline-block;
  width: 100px;
}
.button {
  margin-top: 2vh;
}
.tableAll {
  width: 100%;
  display: flex;
  justify-content: space-between;
  height: 600px;
}
.dialogTable {
  height: 500px;
}
.el-dialog .el-input {
  max-width: 220px;
}
</style>